const downloadFile = (urlFile, fileName) => {
    // Ruta al archivo en tu servidor
    const fileUrl = urlFile;
    console.log(urlFile);
    
    // Crear elemento <a> temporal
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName; // Nombre con el que se descargará
    
    // Simular click
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
}

export default downloadFile;